var map = {
	"./dailyCashback.png": 67409,
	"./dailyVipReward.png": 6593,
	"./deposit.png": 61468,
	"./desc1.png": 3954,
	"./desc2.png": 94665,
	"./desc3.png": 39840,
	"./desc4.png": 91167,
	"./monthlyCashback.png": 43265,
	"./spin.png": 16608,
	"./upgradeReward.png": 94563,
	"./vipDay.png": 19717,
	"./vipDayReward.png": 13260,
	"./wager.png": 85024,
	"./weeklyCashback.png": 84665,
	"./weeklyVipReward.png": 8937,
	"./withdrawLimit.png": 445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73007;